import _classCallCheck from "@babel/runtime/helpers/classCallCheck";

/**
 * ported from filament
 */
export var VirtualResource = function VirtualResource() {
  _classCallCheck(this, VirtualResource);

  this.first = void 0;
  this.last = void 0;
};
//# sourceMappingURL=VirtualResource.js.map